(function(){
  var CANVAS_ID = window.PQC_CONFIG.canvasId;
  var IMG_URL   = 'https://cdn.shopify.com/s/files/1/0948/0595/0778/files/all_pins.jpg?v=1780388815';

  var OPT = {
    revealRadius:   0.30,
    revealSoftness: 0.90,
    pixelSize:      3.0,
    waveSpeed:      0.28,
    waveFrequency:  2.2,
    waveAmplitude:  0.10,
    mouseRadius:    0.24
  };

  var vert = [
    'varying vec2 vUv;',
    'void main(){ vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0); }'
  ].join('\n');

  var frag = [
    'precision highp float;',
    'uniform sampler2D uTexture;',
    'uniform float uTime, uRevealRadius, uRevealSoftness, uPixelSize, uMouseActive;',
    'uniform float uWaveSpeed, uWaveFrequency, uWaveAmplitude, uMouseRadius;',
    'uniform float uImageAspect, uCanvasAspect;',
    'uniform vec2 uMouse;',
    'varying vec2 vUv;',

    'float bayer4x4(vec2 pos){',
    '  int x=int(mod(pos.x,4.0)); int y=int(mod(pos.y,4.0)); int index=x+y*4;',
    '  float p[16];',
    '  p[0]=0.0; p[1]=8.0; p[2]=2.0; p[3]=10.0;',
    '  p[4]=12.0;p[5]=4.0; p[6]=14.0;p[7]=6.0;',
    '  p[8]=3.0; p[9]=11.0;p[10]=1.0;p[11]=9.0;',
    '  p[12]=15.0;p[13]=7.0;p[14]=13.0;p[15]=5.0;',
    '  for(int i=0;i<16;i++){ if(i==index) return p[i]/16.0; }',
    '  return 0.0;',
    '}',

    'vec2 coverUv(vec2 uv){',
    '  vec2 s=vec2(1.0);',
    '  if(uCanvasAspect>uImageAspect) s.y=uImageAspect/uCanvasAspect;',
    '  else s.x=uCanvasAspect/uImageAspect;',
    '  return (uv-0.5)*s+0.5;',
    '}',

    'void main(){',
    '  vec2 uv=vUv;',
    '  vec2 suv=coverUv(uv);',
    '  float waveStrength=uWaveAmplitude*0.1;',
    '  suv.x += sin(uv.y*uWaveFrequency+uTime*uWaveSpeed)*waveStrength;',
    '  suv.y += sin(uv.x*uWaveFrequency*0.7+uTime*uWaveSpeed*0.8)*waveStrength*0.5;',
    '  if(uMouseActive>0.01){',
    '    float dist=distance(uv,uMouse);',
    '    float infl=smoothstep(uMouseRadius,0.0,dist);',
    '    float ripple=sin(dist*uWaveFrequency*5.0-uTime*uWaveSpeed)*uWaveAmplitude*0.05*infl*uMouseActive;',
    '    suv+=ripple;',
    '  }',
    '  vec4 color=texture2D(uTexture,suv);',
    '  float revealDist=distance(uv,uMouse);',
    '  float inner=uRevealRadius*(1.0-uRevealSoftness);',
    '  float revealAmount=(1.0-smoothstep(inner,uRevealRadius,revealDist))*uMouseActive;',
    '  vec3 finalColor = color.rgb;',
    '  gl_FragColor=vec4(finalColor,1.0);',
    '}'
  ].join('\n');

  function initReveal(){
    var canvas = document.getElementById(CANVAS_ID);
    if(!canvas || typeof THREE === 'undefined') return;

    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: false, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));

    var scene  = new THREE.Scene();
    var camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 10);
    camera.position.z = 1;

    var uniforms = {
      uTexture:       { value: null },
      uTime:          { value: 0 },
      uMouse:         { value: new THREE.Vector2(-10, -10) },
      uRevealRadius:  { value: OPT.revealRadius },
      uRevealSoftness:{ value: OPT.revealSoftness },
      uPixelSize:     { value: OPT.pixelSize },
      uMouseActive:   { value: 0 },
      uWaveSpeed:     { value: OPT.waveSpeed },
      uWaveFrequency: { value: OPT.waveFrequency },
      uWaveAmplitude: { value: OPT.waveAmplitude },
      uMouseRadius:   { value: OPT.mouseRadius },
      uImageAspect:   { value: 1 },
      uCanvasAspect:  { value: 1 }
    };

    var mat  = new THREE.ShaderMaterial({ vertexShader: vert, fragmentShader: frag, uniforms: uniforms });
    var mesh = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), mat);
    scene.add(mesh);

    var loader = new THREE.TextureLoader();
    loader.setCrossOrigin('anonymous');
    loader.load(IMG_URL, function(tex){
      tex.minFilter = THREE.LinearFilter;
      tex.magFilter = THREE.LinearFilter;
      uniforms.uTexture.value = tex;
      uniforms.uImageAspect.value = (tex.image.width || 1) / (tex.image.height || 1);
      resize();
      renderer.render(scene, camera);
    });

    function resize(){
      var w = canvas.clientWidth  || canvas.offsetWidth;
      var h = canvas.clientHeight || canvas.offsetHeight;
      if(!w || !h) return;
      renderer.setSize(w, h, false);
      uniforms.uCanvasAspect.value = w / h;
    }
    window.addEventListener('resize', resize);
    resize();

    var section = canvas.closest(window.PQC_CONFIG.sectionSelector) || canvas.parentElement;
    var inside = false, entered = false, active = 0;

    section.addEventListener('pointermove', function(e){
      var r = canvas.getBoundingClientRect();
      uniforms.uMouse.value.set(
        (e.clientX - r.left)  / r.width,
        1 - (e.clientY - r.top) / r.height
      );
      entered = true;
    });
    section.addEventListener('pointerenter', function(){ inside = true; });
    section.addEventListener('pointerleave', function(){ inside = false; });

    var clock = new THREE.Clock();
    (function frame(){
      requestAnimationFrame(frame);
      if(uniforms.uTexture.value){
        if(!reduce) uniforms.uTime.value = clock.getElapsedTime();
        var target = inside ? 1 : 0;
        active += (target - active) * 0.08;
        uniforms.uMouseActive.value = entered ? active : 0;
        renderer.render(scene, camera);
      }
    })();
  }

  // Wait for Three.js deferred script to load
  function tryInit(){
    if(typeof THREE !== 'undefined'){ initReveal(); }
    else { setTimeout(tryInit, 50); }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryInit);
  else tryInit();
})();